import Vue from 'vue'
import Vuex from 'vuex'

// Vuex Persist
// import VuexPersistence from 'vuex-persist'
// const vuexLocal = new VuexPersistence({
//     storage: window.localStorage
// })

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        user: {},
        categories: [],
        pages: [],
    },
    mutations: {
        login(state, payload) {
            state.token = payload.token
            state.user = payload.user
            Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + payload.token
            localStorage.setItem('token', payload.token)
        },

        setUser(state, payload) {
            state.user = payload
        },

        logout(state) {
            state.user = {}
            state.token = ''
            Vue.prototype.$http.defaults.headers.common['Authorization'] = ''
            localStorage.removeItem('token')
        },

        storeCategories(state, payload) {
            state.categories = payload
        },

        storePages(state, payload) {
            state.pages = payload
        },

        clearStaffId(state) {
            if (state.user) {
                state.user.current_staff_id = ""
            }
        }
    },
    actions: {

    },
    getters: {
        user(state) {
            return state.user
        },

        token(state) {
            return state.token
        },

        isAuthorized(state) {
            return state.token != ''
        },

        categories(state) {
            return state.categories
        },

        pages(state) {
            return state.pages
        },

        categoryBySlug: (state) => (slug) => {
            return state.categories.find(category => category.slug == slug)
        },

        pageBySlug: (state) => (slug) => {
            return state.pages.find(page => page.slug == slug)
        },

        footerPages: (state) => {
            return state.pages.filter(page => { return page.in_footer == true })
        },

        categoryList: (state) => {
            var list = [];

            state.categories.forEach(category => {
                list.push({
                    id: category.id,
                    title: category.title,
                });
            });

            return list;
        },
    },
    // plugins: [vuexLocal.plugin]
})
